import { useEffect } from "react";

declare global {
  interface Window {
    EkoSDK: any;
  }
}

const EkoAIWidget: React.FC = () => {
  useEffect(() => {
    if (!window.EkoSDK) {
      console.error("EkoSDK not loaded.");
      return;
    }

    const instance = window.EkoSDK.init({
      homescreen: {
        title: "AI-powered Tollring-Call Analytics",
        subtitle: "Boost your business, gain smart insights, optimize calls, and enhance productivity effortlessly!",
        questionListTitle: "Please ask some question",
        questions: [
          {
            type: "deep_research",
            label: "Help me review the customer's sentiment, find the reason why the sentiment has been drop?",
            value: "Help me review the customer's sentiment, find the reason why the sentiment has been drop?",
          },
          {
            type: "normal",
            label: "How effective was the agent in executing the outbound call to achieve a successful sales outcome and establish a clear path forward?",
            value: "How effective was the agent in executing the outbound call to achieve a successful sales outcome and establish a clear path forward?",
          },
        ],
      },
      authEndpoint: "https://ekoai.ekoapp.com",
      apiEndpoint: "https://webchat.amitysolutions.com",
      channelId: "6839bb850ab667a669fc7be8",
      agentId: "691e3e07-bb84-46f2-899b-4afe40731416",
      apiKey: "c2b728b0f038138f9be147a89344a50c",
      userId: "1", // TODO Update the value correctly
    });

    instance.observer.setObserver({
      onAppAction: (action: any) => {
        console.log("onAppAction", action);
        return "Hello from React TS";
      },
      onNewMessage: (data: any) => {
        console.log("onNewMessage", data);
      },
    });

    const interval = setInterval(() => {
    const host = document.querySelector("#eko-sdk-host") as HTMLElement;
    const shadow = host?.shadowRoot;
    const wrapper = shadow?.querySelector("#eko-sdk-wrapper") as HTMLElement;

    if (wrapper) {
      wrapper.style.zIndex = "9999";
      // wrapper.style.position = "fixed"; // required for z-index
      clearInterval(interval); // once applied, stop the loop
    }
  }, 500); 

  return () => clearInterval(interval);

  }, []);

  return (
    <div>
      {/* <p>AI Chat Widget Initialized</p> */}
    </div>
  );
};

export default EkoAIWidget;
